
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pledges",
      function () {
        return require("private-next-pages/pledges/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pledges"])
      });
    }
  